import { connect }    from 'react-redux';
import LoadingBar from 'react-redux-loading-bar';

const mapStateToProps = (state) => ({
  loading: state.get('loadingBar'),
});

export default connect(mapStateToProps)(LoadingBar.WrappedComponent);



// WEBPACK FOOTER //
// ./app/javascript/mastodon/features/ui/containers/loading_bar_container.js